import { createApp } from 'vue'
import App from './App.vue'

import VideoPlayer from 'vue-video-player'
import hls from 'videojs-contrib-hls';

import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';

createApp(App).use(hls).use(VideoPlayer).mount('#app')
